import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { ConfigPage, NextPageWithLayoutAndPageType } from "types/index";

const Movie: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props.config || storeConfig;
  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "movie",
  )?.config;
  const description =
    seoconfig?.description ||
    `Browse all currently showing movies at ${siteName}. Check showtimes, book tickets, and enjoy the latest releases.`;
  const title = seoconfig?.title || "Movies";
  const keywords = seoconfig?.keywords || [
    "movies",
    "now showing",
    "cinema",
    "movie tickets",
    "showtimes",
    siteName,
  ];

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

Movie.page_type = "movie";
export const getServerSideProps = getConfigSSR;

export default Movie;
